// Mirrors Masterpiece.Core.Enums.LinkType on the backend.
export const LINK_TYPES = [
    { value: 0, label: "Prilagođeno (Custom)" },
    { value: 1, label: "Sustav rezervacija" },
    { value: 2, label: "Jelovnik" },
    { value: 3, label: "Web stranica" },
    { value: 4, label: "Telefon" },
    { value: 5, label: "WhatsApp" },
    { value: 6, label: "TripAdvisor" },
    { value: 7, label: "Google Maps" },
    { value: 8, label: "Facebook" },
    { value: 9, label: "Instagram" },
    { value: 10, label: "YouTube" },
    { value: 11, label: "Email" },
    { value: 12, label: "TikTok" },
    { value: 13, label: "LinkedIn" },
];

export const LINK_TYPE_LABELS = LINK_TYPES.reduce((map, type) => {
    map[type.value] = type.label;
    return map;
}, {});
